var _circle, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapeVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 512c77.591 0 147.114-34.524 194.061-89.043h-388.122c46.947 54.519 116.47 89.043 194.061 89.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-141.384-114.616-256-256-256s-256 114.616-256 256c0 23.107 3.08 45.489 8.819 66.783h494.363c5.738-21.294 8.818-43.676 8.818-66.783z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.348 356.174c4.935 11.596 10.704 22.748 17.227 33.391h436.852c6.521-10.644 12.29-21.796 17.227-33.391z",
    fill: "#d80027"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m182.99 272.696 4.144 12.754h13.411l-10.849 7.883 4.144 12.754-10.85-7.883-10.85 7.883 4.145-12.754-10.849-7.883h13.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.99 439.652 4.144 12.755h13.411l-10.849 7.882 4.144 12.754-10.85-7.882-10.85 7.882 4.145-12.754-10.849-7.882h13.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.274 383.189 4.144 12.753h13.411l-10.849 7.882 4.144 12.756-10.85-7.883-10.85 7.883 4.146-12.756-10.85-7.882h13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.959 289.391 4.144 12.755h13.41l-10.848 7.882 4.144 12.755-10.85-7.883-10.85 7.883 4.146-12.755-10.851-7.882h13.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.72 341.915 13.408.001 4.145-12.757 4.145 12.756 13.411-.001-10.85 7.883 4.145 12.755-10.851-7.883-10.849 7.88 4.144-12.753z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.11 453.911 4.144-12.752-10.851-7.882h13.411l4.145-12.755 4.145 12.754h13.41l-10.85 7.882 4.144 12.756-10.85-7.884z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.677 383.189-4.143 12.753h-13.411l10.848 7.882-4.144 12.756 10.85-7.883 10.85 7.883-4.145-12.756 10.85-7.882h-13.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.992 289.391-4.143 12.755h-13.411l10.848 7.882-4.144 12.755 10.85-7.883 10.85 7.883-4.145-12.755 10.85-7.882h-13.411z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.232 341.915-13.409.001-4.145-12.757-4.144 12.756-13.411-.001 10.849 7.883-4.145 12.755 10.851-7.883 10.849 7.88-4.144-12.753z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.841 453.911-4.143-12.752 10.85-7.882h-13.411l-4.145-12.755-4.144 12.754h-13.411l10.85 7.882-4.144 12.756 10.85-7.884z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapeVerde);
export default __webpack_public_path__ + "static/media/capeVerde.7d46400df2aab177cc22eabae5a81b9e.svg";
export { ForwardRef as ReactComponent };